import { subDays } from 'date-fns';

export function oldPlanEndDate(splitDate: Date): Date {
  return subDays(splitDate, 1);
}
